// Strona główna (sesja 37 po rundzie R3, hero z rundy 41-D-R2 — paczka HD).
//
// Droga do jednej akcji, w tej kolejności: PAS PRZYPIĘCIA z hero D „schemat metra” (nadtytuł,
// hasło w dwóch zdaniach, zdanie pod nim, mapa: utwór → seria → trzy konta → publikacje z dniem
// i godziną, akcja z mikrotekstem i cichym linkiem), pod nim pokaz trzech editów z 37-R3 jako
// osobna sekcja, trzy kroki z wizualizacjami BEZ SŁÓW, koszt w tokenach z linią pieniędzy,
// sekcja zamykająca z rzędem faktów i stopka w trzech grupach.
//
// PAS PRZYPIĘCIA (decyzja właściciela 22.09: „oddalenie żeby działało automatycznie”): pierwszy
// ekran (nagłówek + hero) jest `sticky` w pasie 3 ekranów (2,5 od 1336 px), a przewijanie przez
// pas oddala kamerę mapy od klatki D-01 aż do ~100 kont; w górę wraca. W przypięciu zmienia się
// TYLKO mapa: hasło, akcja i nagłówek stoją jak przy p = 0 (nagłówek przykleja się dopiero za
// pasem). Przy `prefers-reduced-motion` pasa nie ma, a pod hero stoi druga, statyczna mapa
// z lotu ptaka (p = 1). Kamera, LOD i ruch wejścia: `hooks/useHeroZoom.ts`.
//
// NA 390 JEST JESZCZE JEDNA DROGA: dolny pasek akcji, który wchodzi dopiero wtedy,
// gdy pas przypięcia (a z nim przycisk hero) zjedzie z ekranu, i chowa się przy sekcji
// zamykającej, która ma własną akcję. NIGDY nie staje razem z paskiem cookie —
// to była pułapka rundy R2: dwa paski przy dolnej krawędzi zasłaniają się nawzajem,
// a ten u dołu jest gatem prawnym. Kiedy pasek jest widoczny, akcja nagłówka
// przechodzi w obrys, żeby na ekranie stał JEDEN pełny przycisk.
//
// Zdania opisu pod krokami odpadły (zasada 8): wizualizacja mówi to samo, a całą
// sekcję domyka JEDNO zdanie „Nic nie wychodzi bez Twojej zgody.”.
//
// Dane przykładowe (uchwyty kont, tytuły, terminy) są STAŁĄ W KODZIE, nie słownikiem
// — tak samo jak trzy edity sceny w `LandingEditShowcase.tsx` (MAPA 37, „Nowe teksty”).
// Liczby są prawdziwe: premia startowa wychodzi z `lib/startBonus.ts` (czyli z katalogu
// w `app/billing/costs.py`), a cena w linii pieniędzy z `/api/billing/plans` — z tego
// samego katalogu, z którego liczy Cennik. Bez odpowiedzi linia pieniędzy nie powstaje.

import { useCallback, useRef, useState } from 'react'
import { Link } from 'react-router'
import { useI18n } from '../lib/i18n'
import { usePublicPath } from '../lib/publicPaths'
import { usePlans } from '../hooks/useBilling'
import { price as money } from '../lib/money'
import { editWord } from '../locales/plural'
import { TokenAmount } from '../ds/primitives/TokenAmount'
import { FREE_START_EDITS } from '../lib/startBonus'
import Icon from '../components/Icon'
import Seo from '../components/Seo'
import CookieBar from '../components/CookieBar'
import LandingEditShowcase from '../components/LandingEditShowcase'
import LandingFlowMap from '../components/public/LandingFlowMap'
import { Glyph37 } from '../components/public/glyphs37'
import type { Glyph37Name } from '../components/public/glyphs37'
import PublicHeader, { PUBLIC_HEADER_H } from '../components/public/PublicHeader'
import { useGone } from '../hooks/useGone'
import PublicFooterBar from '../components/public/PublicFooterBar'
import { heroProgress, useHeroMedia } from '../hooks/useHeroZoom'
import '../styles/minimal-public.css'

/**
 * Stawka tokenów za akcję (reguła 34, decyzja Domiego 20.09): 1 edit = 1 token,
 * 1 publikacja = 1 token.
 *
 * Liczby stoją TUTAJ, a nie przychodzą z `/api/billing/plans`, bo katalog backendu
 * nadal liczy w gemach po starych stawkach — przejście backendu na tokeny to osobna
 * pozycja („do backendu po akceptacji”, brief paczki 37b), a strona publiczna ma
 * pokazywać cennik, który właściciel zatwierdził. Gdy backend przejdzie, te dwie
 * stałe znikają na rzecz `plans.data.gem_costs`.
 */
const TOKENS_PER_EDIT = 1
const TOKENS_PER_PUBLISH = 1

/** Fala kroku 01: 48 słupków, środkowy fragment zaznaczony akcentem (artboard 01). */
const WAVE: [number, boolean][] = [
  [7, false], [7, false], [6, false], [9, false], [9, false], [5, false], [5, false], [6, false],
  [2, false], [1, false], [4, false], [3, false], [2, false], [7, false],
  [8, true], [6, true], [8, true], [9, true], [5, true], [4, true], [5, true], [2, true],
  [1, true], [4, true], [4, true], [3, true], [7, true], [9, true], [7, true], [7, true],
  [9, true], [5, true], [2, true], [4, true],
  [3, false], [1, false], [3, false], [6, false], [4, false], [6, false], [9, false], [7, false],
  [6, false], [8, false], [5, false], [2, false], [3, false], [3, false],
]
const WAVE_H = [12, 22, 34, 46, 58, 70, 82, 92, 100]

/** Kroku 02: cztery kadry serii, trzy zaznaczone. */
const FRAMES: { k: string; on: boolean }[] = [
  { k: 'nostalgia-01-mokry-chodnik-t01', on: true },
  { k: 'nostalgia-02-przystanek-we-mgle-t03', on: false },
  { k: 'nostalgia-03-latarnia-i-deszcz-t01', on: true },
  { k: 'nostalgia-04-ulica-o-zmierzchu-t01', on: true },
]

/** Kroku 03: trzy prawdziwe wiersze postów z terminem i znacznikiem zatwierdzenia. */
const POSTS: { k: string; handle: string; when: { pl: string; en: string }; ok: boolean }[] = [
  { k: 'nostalgia-01-mokry-chodnik-t01', handle: '@nocna.zmiana', when: { pl: 'pon 21.09, 18:00', en: 'Mon 21.09, 18:00' }, ok: true },
  { k: 'nostalgia-03-latarnia-i-deszcz-t01', handle: '@nocna.jazda', when: { pl: 'wt 22.09, 12:30', en: 'Tue 22.09, 12:30' }, ok: true },
  { k: 'nostalgia-04-ulica-o-zmierzchu-t01', handle: '@zostan.chwile', when: { pl: 'śr 23.09, 20:00', en: 'Wed 23.09, 20:00' }, ok: false },
]

/** Pięć faktów sekcji zamykającej: glif z arkusza sesji + jedno zdanie. */
const FACTS: { g: Glyph37Name; k: string }[] = [
  { g: 'nocard', k: 'fact1' },
  { g: 'lock', k: 'fact2' },
  { g: 'key', k: 'fact3' },
  { g: 'shield', k: 'fact4' },
  { g: 'calx', k: 'fact5' },
]

/** Kotwica sekcji trzech kroków: cel cichego linku hero („Zobacz, jak to działa”). */
const HOW_ID = 'trzy-kroki'

/**
 * „Plany od {price} / mies.” z kwotą jako DRUGĄ liczbą zdania (reguła 25: mono 32/600).
 *
 * Zdanie rozcinamy po znaczniku podstawionym w miejsce `{price}`, a nie po samej kwocie:
 * kwota bywa podciągiem reszty zdania („od 29,99 €” w innym języku mogłaby się powtórzyć),
 * a znacznik U+241F nie występuje w żadnym tekście, który ktokolwiek napisze.
 */
const MONEY_SLOT = '␟'

function MoneyLine({ from, t }: { from: string; t: (k: string, v?: Record<string, string | number>) => string }) {
  const [before, after = ''] = t('landing.price.from', { price: MONEY_SLOT }).split(MONEY_SLOT)
  return <p className="mp-money">{before}<b className="mp-money-num">{from}</b>{after}</p>
}

export default function Landing() {
  const { t, locale } = useI18n()
  const pub = usePublicPath()
  const plans = usePlans()
  const stage = useRef<HTMLDivElement>(null)
  const screenRef = useRef<HTMLDivElement>(null)
  const closing = useRef<HTMLDivElement>(null)
  // Ruch dozwolony = przypięcie hero; szerokość = orientacja mapy. Czytane synchronicznie, żeby
  // pierwszy render klienta nie przeskoczył o dwa ekrany po montażu.
  const { motion, wide } = useHeroMedia()
  const stageGone = useGone(stage)
  const closingAway = useGone(closing)
  // Nagłówek wypełnia swoją akcję dopiero, gdy żaden wypełniony przycisk tej samej drogi
  // nie stoi na ekranie (VB-10): pomiar na SAMYCH przyciskach, nie na końcu pasa przypięcia
  // — pas zwalnia się, zanim przycisk hero zjedzie z ekranu.
  const heroCta = useRef<HTMLAnchorElement>(null)
  const closingCta = useRef<HTMLAnchorElement>(null)
  const heroCtaGone = useGone(heroCta)
  const closingCtaGone = useGone(closingCta)
  // Pasek cookie ma pierwszeństwo przy dolnej krawędzi: jest gatem prawnym, a nie
  // propozycją. Stan przychodzi z samego paska, bo człowiek może go zamknąć przy
  // otwartej stronie — i wtedy pasek akcji ma wejść, a nie czekać na przeładowanie.
  const [cookieOnScreen, setCookieOnScreen] = useState(false)
  const ctaBar = stageGone && closingAway && !cookieOnScreen
  // Nagłówek przykleja się dopiero na końcu drogi kamery (ten sam pomiar co kamera): w przypięciu
  // ma wyglądać jak przy p = 0, a nie przejść na pasek 56 px z drugim wypełnionym przyciskiem.
  const stuckFrom = useCallback(() => {
    const pin = stage.current
    const scr = screenRef.current
    return pin && scr ? heroProgress(pin, scr).end : PUBLIC_HEADER_H
  }, [])

  const [line1, line2] = t('landing.hero.titleD').split('\n')
  const micro = t('landing.hero.micro', { n: FREE_START_EDITS, edits: editWord(locale, FREE_START_EDITS) })

  // Linia pieniędzy: najtańszy plan, który da się kupić. Bez katalogu nie ma linii —
  // „od 0 €” i „od —” to dwa sposoby na powiedzenie nieprawdy o cenie.
  const cheapest = (plans.data?.plans ?? [])
    .filter((p) => p.purchasable && p.price_cents > 0)
    .sort((a, b) => a.price_cents - b.price_cents)[0] ?? null
  const from = cheapest ? money(cheapest.price_cents, plans.data?.currency ?? 'EUR', locale) : null

  return (
    <div className={`mp${ctaBar ? ' has-cta-bar' : ''}`}>
      <Seo page="landing" />

      <div className={`mp-fm-pin${motion ? ' mp-fm-pinned' : ''}`} ref={stage}>
        <div className="mp-dark mp-fm-screen" ref={screenRef}>
          <PublicHeader onStage stuckFrom={motion ? stuckFrom : undefined} quietCta={!heroCtaGone || !closingCtaGone} />
          <section className="mp-hero">
            <div className="mp-hero-hx">
              <p className="mp-eyebrow">{t('landing.hero.eyebrow')}</p>
              <h1><span>{line1}</span>{line2 ? <span>{line2}</span> : null}</h1>
              <p className="mp-hero-lead">{t('landing.hero.leadD')}</p>
            </div>
            <LandingFlowMap wide={wide} pin={stage} screen={screenRef} zoom={motion} />
            <div className="mp-hero-cta">
              <Link to="/register" className="btn btn-primary" data-cta="scena" ref={heroCta}>{t('landing.hero.ctaStart')}</Link>
              <div className="mp-hero-row">
                <small className="mp-hero-micro">{micro}</small>
                <a href={`#${HOW_ID}`} className="mp-hero-how">
                  {t('landing.hero.how')}<Icon name="ArrowRight" size={16} />
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Bez ruchu: widok z lotu ptaka (p = 1) jako druga, statyczna grafika pod hero. */}
      {motion ? null : (
        <div className="mp-dark mp-fm-ptak-band" aria-hidden="true">
          <LandingFlowMap wide={wide} ptak />
        </div>
      )}

      <main>
        {/* Pokaz trzech editów z 37-R3 zostaje pod hero (odstępstwo paczki HD od MAPY D):
            klikalne edity z odtwarzaczem to dowód produktu. Bez nagłówka i bez nowego zdania. */}
        <div className="mp-dark mp-fm-show">
          <section aria-label={t('landing.showcase.title')}>
            <LandingEditShowcase />
          </section>
        </div>

        <section className="mp-sec mp-how" id={HOW_ID} aria-labelledby="landing-how-heading">
          <h2 id="landing-how-heading">{t('landing.how.heading')}</h2>
          <ol className="mp-steps">
            <li className="mp-step">
              <div className="mp-viz">
                <div className="mp-wave" aria-hidden="true">
                  {WAVE.map(([h, on], i) => (
                    <i key={i} className={on ? 'is-on' : undefined} style={{ height: `${WAVE_H[h - 1]}%` }} />
                  ))}
                </div>
              </div>
              <span className="mp-step-no" aria-hidden="true">01</span>
              <h3>{t('landing.how.step1Title')}</h3>
            </li>
            <li className="mp-step">
              <div className="mp-viz mp-viz-frames" aria-hidden="true">
                {FRAMES.map((f) => (
                  <span key={f.k} className={`mp-kadr${f.on ? ' is-on' : ''}`}>
                    <img src={`/kadry/${f.k}.jpg`} alt="" width="360" height="640" loading="lazy" decoding="async" />
                    {f.on ? <span className="mp-kadr-mark"><Icon name="Check" size={12} strokeWidth={2.5} /></span> : null}
                  </span>
                ))}
              </div>
              <span className="mp-step-no" aria-hidden="true">02</span>
              <h3>{t('landing.how.step2Title')}</h3>
            </li>
            <li className="mp-step">
              <div className="mp-viz mp-viz-posts" aria-hidden="true">
                <div className="mp-posts">
                  {POSTS.map((p) => (
                    <div className="mp-post" key={p.handle}>
                      <span className="mp-kadr">
                        <img src={`/kadry/${p.k}.jpg`} alt="" width="360" height="640" loading="lazy" decoding="async" />
                      </span>
                      <span className="mp-post-t">{p.handle}<small>{p.when[locale === 'en' ? 'en' : 'pl']}</small></span>
                      <span className={`mp-post-ok${p.ok ? ' is-on' : ''}`}>
                        <Icon name="Check" size={12} strokeWidth={2.5} />
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <span className="mp-step-no" aria-hidden="true">03</span>
              <h3>{t('landing.how.step3Title')}</h3>
            </li>
          </ol>
          <p className="mp-steps-note">{t('landing.how.note')}</p>
        </section>

        <section className="mp-sec mp-sec-line" aria-labelledby="landing-cost-heading">
          <div className="mp-price">
            <div>
              <h2 id="landing-cost-heading">{t('landing.price.heading')}</h2>
              <p>{t('landing.price.refund')}</p>
              {from ? <MoneyLine from={from} t={t} /> : null}
              <Link to={pub('/pricing')} className="mn-lnk">
                {t('landing.price.link')}<Icon name="ArrowRight" size={16} />
              </Link>
            </div>
            <div className="mp-price-nums">
              <div>
                <span>{t('landing.price.oneEdit')} =</span>
                {/* N11 (P1-04, reguła 48): glif i liczba, bez słowa na ekranie; słowo słyszy czytnik. */}
                <b><TokenAmount locale={locale} n={TOKENS_PER_EDIT} place="balance" /></b>
              </div>
              <div>
                <span>{t('landing.price.onePublish')} =</span>
                <b><TokenAmount locale={locale} n={TOKENS_PER_PUBLISH} place="balance" /></b>
              </div>
            </div>
          </div>
        </section>

        {/* Sekcja zamykająca: jedna akcja i rząd faktów, z których każdy da się
            sprawdzić na tej samej stronie (artboard 01, „Pierwsza seria jest za darmo.”). */}
        <div className="mp-dark mp-closing" ref={closing}>
          <section className="mp-sec" aria-labelledby="landing-closing-heading">
            <h2 id="landing-closing-heading">{t('landing.closing.heading')}</h2>
            <div className="mp-closing-cta">
              <Link to="/register" className="btn btn-primary" data-cta="zamkniecie" ref={closingCta}>{t('landing.nav.startFree')}</Link>
              <small>{micro}</small>
            </div>
            <ul className="mp-facts">
              {FACTS.map((f) => (
                <li key={f.k}>
                  <Glyph37 name={f.g} size={18} />
                  <span>{t(`landing.closing.${f.k}`)}</span>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </main>

      <PublicFooterBar />
      {/* Pasek cookie żyje na stronie treści, nie w powłoce aplikacji: to jedyny
          ekran, na którym artboard go rysuje, a jego wysokość rezerwuje scena. */}
      <CookieBar onVisible={setCookieOnScreen} />
      {ctaBar ? (
        <div className="mp-cta-bar">
          <Link to="/register" className="btn btn-primary" data-cta="pasek">{t('landing.nav.startFree')}</Link>
          <small>{micro}</small>
        </div>
      ) : null}
    </div>
  )
}
